import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { SUPPORT_EMAIL } from '../constants';
import useHead from '../useHead';

export default function Terms() {
  useHead({
    title: 'Terms of Service — ConvoLines',
    description:
      'The terms that govern your use of the ConvoLines app and website, including subscriptions, billing, and acceptable use.',
    path: '/terms',
  });

  return (
    <div className="page">
      <Header />
      <section className="section legal">
        <h1>Terms of Use</h1>
        <p>Last updated: September 7, 2026</p>

        <p>
          These Terms of Use govern your use of the ConvoLines mobile app. By using
          ConvoLines, you agree to these terms.
        </p>

        <h2>The service</h2>
        <p>
          ConvoLines provides English-conversation and expression practice content. All
          content is free to use and supported by ads; an optional Premium
          subscription removes the ads.
        </p>

        <h2>Accounts</h2>
        <p>
          Creating an account is optional. If you do create one, you're responsible
          for keeping your credentials secure and for activity under your account.
        </p>

        <h2>Subscriptions &amp; billing</h2>
        <p>
          ConvoLines Premium is offered as auto-renewing monthly or yearly
          subscriptions. The plan title, length, and price are shown in the app
          before purchase. Payment is charged to your Apple ID or Google account at
          confirmation of purchase, and subscriptions renew automatically unless
          auto-renew is turned off at least 24 hours before the end of the current
          period. Manage or cancel your subscription any time in your App Store or
          Google Play account settings. Refunds are handled by Apple or Google
          according to their respective policies — we cannot issue refunds directly.
        </p>

        <h2>Acceptable use</h2>
        <p>
          Don't misuse the app — including attempting to disrupt the service,
          reverse-engineer it, or access it through unauthorized means.
        </p>

        <h2>Intellectual property</h2>
        <p>
          All content in ConvoLines (conversations, expressions, audio, and app
          design) is owned by us or our licensors and may not be copied or
          redistributed without permission.
        </p>

        <h2>Termination</h2>
        <p>
          You may stop using ConvoLines and delete your account at any time. We may
          suspend or terminate access for violations of these terms.
        </p>

        <h2>Disclaimer &amp; limitation of liability</h2>
        <p>
          ConvoLines is provided "as is" without warranties of any kind. To the
          extent permitted by law, we are not liable for indirect or consequential
          damages arising from your use of the app.
        </p>

        <h2>Changes to these terms</h2>
        <p>
          We may update these terms from time to time. Continued use of the app
          after changes take effect constitutes acceptance of the updated terms.
        </p>

        <h2>Contact</h2>
        <p>
          Questions about these terms? Email us at{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
        </p>
      </section>
      <Footer />
    </div>
  );
}
